import { Injectable } from '@angular/core';
@Injectable({
	providedIn: 'root'
})

export class GridPagerService 
{
	getPager(totalItems: number, currentPage: number, pageSize: number = 10) 
	{
       
		const totalPages = Math.ceil(totalItems / pageSize);

		let startPage: number, endPage: number;
		if (totalPages <= 5) 
		{
			startPage = 1;
			endPage = totalPages;
		}
		else 
		{
			const startEndObj=this.getCurrentPage( currentPage, totalPages);
			startPage=startEndObj.startPage;
			endPage=startEndObj.endPage;
			
		}

		const startIndex = (currentPage - 1) * pageSize;
		const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);


		return {
			totalItems: totalItems,
			currentPage: currentPage,
			pageSize: pageSize,
			totalPages: totalPages,
			startPage: startPage,
			endPage: endPage,
			startIndex: startIndex,
			endIndex: endIndex
            
		};
	}
	getCurrentPage(currentPage:number, totalPages:number )
	{
		let startPage: number, endPage: number;
		if (currentPage <= 3) 
		{
			startPage = 1;
			endPage = 5;
		}
		else if (currentPage + 1 >= totalPages) 
		{
			startPage = totalPages - 4;
			endPage = totalPages;
		}
		else 
		{
			startPage = currentPage - 2;
			endPage = currentPage + 2;
		}
		return { startPage: startPage, endPage: endPage };
	}
}
